import { render, staticRenderFns } from "./OfficeDirectorHome.vue?vue&type=template&id=624096d1&scoped=true"
import script from "./OfficeDirectorHome.vue?vue&type=script&lang=js"
export * from "./OfficeDirectorHome.vue?vue&type=script&lang=js"
import style0 from "./OfficeDirectorHome.vue?vue&type=style&index=0&id=624096d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624096d1",
  null
  
)

export default component.exports